<template>
  <div>
    <!-- 右边弹框 -->
    <van-popup v-model="langShow" position="right">
      <div class="main-box">
        <div class="box">
          <div class="title-box">
            <h2>{{ $t('yuyan') }}</h2>
            <button type="button" class="btn" @click="langShow = false">
              <i class="iconfont icon-guanbi"></i>
            </button>
          </div>
          <div class="uls">
            <div class="t-box">
              <div class="li" @click.stop="showLangStatus = !showLangStatus">
                <div class="logos">
                  <img :src="require(`../../assets/images/langLogo/${lang}.png`)" alt="">
                </div>
                <div class="t-text">
                  {{ lang_list[lang] }}
                </div>
                <div class="icon" :class="{ 'xz': showLangStatus }">
                  <i class="iconfont icon-xiajiantou"></i>
                </div>
              </div>
              <div class="boxs" v-if="showLangStatus">
                <a class="lis" :class="{ 'active-li': lang === key }" v-for="(item, key) in lang_list" :key="key"
                  @click="changeLang(key)">
                  <img :src="require(`../../assets/images/langLogo/${key}.png`)" alt="">
                  <span>{{ item }}</span>
                </a>
              </div>
            </div>
            <div style="height: 50px;"></div>
          </div>
        </div>
      </div>
    </van-popup>
    <img src="@/assets/images/register.png" class="bgImg" alt="">
    <div class="basic_wrap">

      <div class="login_bg">
        <!-- <div
        class="back_left"
        @click="$router.back()"
      /> -->
        <div class="language" @click="toKefuLink">
          <span class="iconfont icon-kefu3"></span>
        </div>
        <div class="language" @click="langShow = true">
          <span class="iconfont icon-yuyan1"></span>
        </div>
        <div style="width: 20px;"></div>
      </div>
      <form class="form">
        <div class="cut_login">
          <a :class="{ 'cur': login_type === 0 }" @click="changeFun(0)">
            <span>{{ $t('sj') }}</span>
          </a>
          <a :class="{ 'cur': login_type === 1 }" @click="changeFun(1)">
            <span>{{ $t('email') }}</span>
          </a>

        </div>
        <div class="item">
          <input v-model.trim="data.name" type="text" class="inp" :placeholder="$t('qsrxm')">
        </div>
        <div class="item" v-if="login_type === 0">
          <a class="text-phone" @click.stop="countryShow = !countryShow">{{ data.country }}</a>
          <input v-model.trim="data.mobile" type="text" class="inp" :placeholder="$t('setpaypwd.pureNumber')">
          <div class="item_box" v-if="countryShow">
            <div class="search-box">
              <input type="text" v-model="searchCode" :placeholder="$t('搜索区号')" @input="inputFun"></input>
            </div>
            <a v-for="(item, index) in countrys" :key="index" :class="{ 'active': item.code === data.country }"
              @click.stop="onSelect(item)">
              <img :src="require(`../../assets/images/flags/${item.code.toLowerCase()}.png`)" alt="">
              <span>+{{ item.dial_code }} {{ item.name }}</span>
            </a>
          </div>
        </div>
        <div class="item" v-if="login_type === 1">
          <input v-model="data.email" type="text" class="inp" :placeholder="$t('请输入邮箱')">
        </div>
        <!-- <div class="item">
				<span class="icon">
					<img src="../images/login/p1.png" alt="">
				</span>
				<input type="text" class="inp" v-model.trim="data.name" placeholder="请输入用户名" />
			</div> -->
        <div class="item">
          <input v-model.trim="data.password" :type="password" class="inp" :placeholder="$t('register.password')">
          <div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
        </div>
        <div class="item">
          <input v-model.trim="data.password2" :type="password" class="inp" :placeholder="$t('qqrmm')">
          <div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
        </div>
        <!-- <div class="item">
        <span class="icon">
          <img
            src="../images/login/lock.png"
            alt=""
          >
        </span>
        <input
          v-model.trim="data.spassword"
          :type="password"
          class="inp"
          :placeholder="$t('register.passwordAgain')"
        >
        <div
          class="eye_bi"
          :class="password == 'text' ? 'eye' : ''"
          @click="showPwd"
        />
      </div> -->

        <!-- 			<div class="item">
				<input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
			</div>
			<div class="item">
				<input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密码" />
			</div> -->

        <div v-if="show_sms > 0" class="item">
          <input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('register.code')">
          <van-count-down :time="time" class="btn get_captcha" @finish="timeCall">
            <template v-slot="timeData">
              <span @click="sendcode">{{
                timeData.seconds > 0
                  ? timeData.seconds
                  : $t('register.sendCode')
              }}</span>
            </template>
          </van-count-down>
        </div>
        <div class="item">
          <input v-model.trim="data.invite_code" type="text" class="inp" :placeholder="$t('可选')"
            :readonly="invite_code_status">
        </div>
      </form>
      <div class="flexs">
        <van-checkbox v-model="checkeds" icon-size="14px" shape="square" checked-color="#3d96ff">
          <span style="color: #ffffff;">{{ $t('wytx') }}</span>
        </van-checkbox>
        <router-link style="color: #FCD34D;margin-left: 5px;" to="/xys">
          {{ $t('用户协议') }}
        </router-link>
      </div>
      <div class="basic_btn sbtn" :class="data.mobile == '' ||
        data.password == ''
        //||data.code == ''
        ? 'no_touch'
        : ''
        " @click="submit">
        {{ $t('register.signUpBtn') }}
      </div>
      <a style="display:block;text-align: center;margin: 20px auto 0px auto;text-decoration: underline; color: #01EDC2;font-size: 14px;font-weight: bold;"
        @click="$router.push('/login')">
        {{ $t('Sign') }}
      </a>
      <van-dialog v-model="statement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
        @click="privacyStatementHide">
      </van-dialog>
      <van-dialog v-model="agreement" confirm-button-color="#fb661e" :close-on-click-overlay="true"
        @click="agreementHider">
      </van-dialog>

      <!-- <div
      v-if="msg_show"
      class="kefu"
      :class="show_kefu ? '' : 'kefu_hide'"
      @click="kefu_to"
    >
      <img class="kefu_img" src="@/assets/images/logo2.png">
    </div> -->
    </div>
  </div>

</template>

<script>
import Vue from "vue";
import { CountDown, Checkbox, Dialog, Toast } from "vant";
import Fetch from "../../utils/fetch";
import { lang_list, lang } from '@/locale/index'
import countryListRaw from '../country-data.js'
Vue.use(CountDown)
  .use(Checkbox)
  .use(Dialog);

export default {
  name: "Register",
  data() {
    return {
      langShow: false,
      showLangStatus: false,
      lang: this.$i18n.locale || lang,
      lang_list: lang_list,
      checkeds: false,
      login_type: 0,
      countryShow: false,
      countrys: [],
      countrys2: [],
      logo: localStorage.getItem('logo') || '',
      time: 0,
      agreement: false,
      statement: false,
      show_kefu: false,
      msg_show: true,
      show_sms: 0,
      kefu_link: '',
      password: "password",
      data: {
        password: "",
        spassword: "",
        email: "",
        mobile: "",
        code: "",
        invite_code: "",
        agent: 10000,
        name: "",
        country: localStorage.getItem('countryCode') || "+55"
      },
      config: {},
      proCode: '',
      invite_code_status: false
    };
  },
  created() {
    this.$parent.footer("user", false);
    Fetch("/index/webconfig").then((r) => {
      this.kefu_link = r.data.kefu_link
    });
    this.countrys = countryListRaw
    this.countrys2 = countryListRaw
    // Fetch("/loan/countrys").then((r) => {
    //   this.countrys = r.data.map(x => {
    //     return { text: x.name, code: x.code }
    //   })
    // });
    // this.getparams();
    // 安卓返回IMEI，苹果返回UID值
    /*BSL.PhoneID('callName');
  window.callName = this.methodName;
  // 获取手机OAID
  BSL.GetOAID('getExternalInfo');
  window.getExternalInfo = this.getExternalInfoData; */
  },
  mounted() {
    if (this.$route.query.invite_code) {
      this.data.invite_code = this.$route.query.invite_code;
      this.invite_code_status = true;
    }
    if (this.$route.query.agent) {
      localStorage.setItem('agent', this.$route.query.agent);
      this.data.agent = this.$route.query.agent;
    } else {
      if (localStorage.getItem('agent')) {
        this.data.agent = localStorage.getItem('agent');
      }
    }
    var that = this;
    document.body.addEventListener(
      "scroll",
      function () {
        if (!that.show_kefu) {
          return;
        }
        that.show_kefu = false;
      },
      false
    );
    document.addEventListener(
      "click",
      function (ev) {
        if (ev.target.className != "kefu_img") {
          that.show_kefu = false;
        }
      },
      false
    );
    Fetch('/index/webconfig', { type: 'web' }).then(res => {
      this.config = res.data
      this.show_sms = res.data.sms_verify
    })
  },
  methods: {
    inputFun() {
            // 如果输入框为空，恢复原始数据
            if (!this.searchCode) {
                this.countrys = [...this.countrys2];
                return;
            }

            // 筛选逻辑：匹配区号中的数字部分
            const searchValue = this.searchCode;
            this.countrys = this.countrys2.filter(item => {
                // 去除code中的+号，只保留数字进行匹配
                const codeNumber = item.dial_code.replace('+', '');
                // 包含匹配（也可以改成开头匹配：codeNumber.startsWith(searchValue)）
                return codeNumber.includes(searchValue);
            });
        },
    changeLang(lang, event) {
      Toast.loading({
        // mask: true,
        duration: 200
      })
      this.lang = lang;
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      window.location.reload()
    },
    changeFun(type) {
      this.login_type = type
    },
    toKefuLink() {
      window.location.href = this.kefu_link
    },
    onSelect(action) {
      this.data.country = '+' + action.dial_code
      this.countryShow = false
    },
    kefu_to() {
      if (this.show_kefu) {
        this.$router.push("/kefu");
      }
      this.show_kefu = !this.show_kefu;
    },
    showPwd() {
      if (this.password == "password") {
        this.password = "text";
      } else {
        this.password = "password";
      }
    },
    methodName(r) {
      this.data.imei = r;
    },
    getExternalInfoData(info) {
      var info = JSON.parse(info);
      console.log(info);
      if (info.code == 0) {
        this.data.oaid = info.oaid;
      }
    },
    getparams() {
      var m = this.$route.query.m;
      this.data.invite_code = m;
    },
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) {
        return;
      }

      if (!this.data.mobile) {
        this.$toast(this.$t('register.phoneEmpty'));
        return;
      }

      this.is_send = true;

      Fetch("/index/register_code", {
        mobile: this.data.mobile,
      })
        .then(() => {
          this.time = 60 * 1000;
          this.$toast({
            background: "#07c160",
            message: this.$t('register.sendSuccess'),
          });
        })
        .catch(() => {
          this.is_send = false;
        });
    },
    submit() {
      if (!this.checkeds) {
        this.$toast(this.$t('qyexy'));
        return;
      }
      if (!this.data.mobile && this.login_type === 0) {
        this.$toast(this.$t('setpaypwd.pureNumber'));
        return false;
      }
      if (this.login_type === 1) {
        const emailReg = /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        const isValid = emailReg.test(this.data.email);
        if (!isValid) {
          this.$toast(this.$t('login.phoneError'));
          return false;
        }
      }
      if (!this.data.password) {
        this.$toast(this.$t('register.passwordEmpty'));
        return false;
      }
      if (this.data.password != this.data.password2) {
        this.$toast(this.$t('qqrmm'));
        return false;
      }
      // if (!this.data.invite_code) {
      //   this.$toast(this.$t('invite_code'));
      //   return false;
      // }

      if (!this.data.code && this.config.sms_verify) {
        this.$toast(this.$t('register.codeEmpty'));
        return false;
      }
      // if (this.data.password != this.data.spassword) {
      //     this.$toast(this.$t('register.passwordError'));
      //     return false;
      // }
      let data = {
        name: this.data.name,
        area_code: this.data.country,
        phone: this.data.mobile,
        email: this.data.email,
        password: this.data.password,
        invite_code: this.data.invite_code,
        status: this.login_type === 0 ? 1 : 0
      }

      Fetch("/index/register", data).then((res) => {
        if (res.code == 1) {
          if (res.data.token) {
            localStorage.setItem('token', res.data.token);
          }
          this.$toast(this.$t('register.signUpSuccess'));
          setTimeout(() => {
            this.$router.replace("/");
          }, 1000)
          return
        }
        this.$toast(res.msg);
      });
    },
    userAgreement() {
      this.agreement = true;
    },
    agreementHider() {
      this.agreement = false;
    },
    privacyStatement() {
      this.statement = true;
    },
    privacyStatementHide() {
      this.statement = false;
    },
  },
};
</script>

<style lang="less" scoped>
.contents {
  width: 100%;
  height: 100dvh;
  background: rgb(6, 14, 23);
  background-image: radial-gradient(760px 440px at 95% 0%, rgba(250, 204, 21, .11), transparent 62%), radial-gradient(840px 560px at -10% 2%, rgba(56, 189, 248, .08), transparent 64%), radial-gradient(780px 520px at 42% 100%, rgba(52, 211, 153, .07), transparent 64%);
}

.login_bg {
  width: 100%;
  height: 50px;
  overflow: hidden;
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;

  .language {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      font-size: 22px;
      color: #01EDC2;
    }
  }

  .languages {
    width: fit-content;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px 0px 10px;

    span {
      font-size: 14px;
      color: #01EDC2;
      --tw-text-opacity: 1;
      text-decoration-line: underline;
    }
  }
}

.basic_wrap {
  width: 100%;
  height: 100%;
  max-width: 750px;
  min-height: 100dvh;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 10;
  background: rgba(0, 0, 0, 0.1);
  padding-top: 30px;
  // background: url('~@/assets/images/bg1.jpg') no-repeat center center / cover;
}

.basic_wrap .form {
  margin: 9em auto 0px auto;
  width: 90%;
  border-radius: 13px;
}

.cut_login {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 18px;
  text-align: center;
  margin: 0 auto;
  background: #E6F0ED;
  border-radius: 10px;
  padding: 4px;
  margin-bottom: 20px;

  a {
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #4B5563;
    position: relative;
    font-size: 14px;

    .line {
      width: 100%;
      height: 1px;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: #f2f2f2;
    }
  }

  .curs {
    width: 20%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: underline;
  }

  a.cur {
    color: #10B981;
    background: #fff;
    border-radius: 6px;

    .line {
      height: 2px;
      background-image: linear-gradient(to right, #000, #000);
    }
  }
}

.block {
  width: 100%;
  height: 100%;
  // overflow:hidden;
  // margin: 10% auto;
  font-size: 15px;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;

  .block-title {
    display: block;
    font-weight: bolder;
    line-height: 39px;
    height: 39px;
    text-align: center;
  }

  .p_agr {
    // padding-top:30rpx;
    font-size: 12px;
    /*font-weight: bolder;*/
    line-height: 20px;
    padding: 0px 10px;
    height: 388px;
    /*overflow: hidden;*/
    // overflow: auto;
    -webkit-overflow-scrolling: touch;
    overflow-y: scroll;
  }

  .div_qd {
    width: 60px;
    height: 25px;

    span {
      width: 60px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      justify-content: center;
      background: #fb661e;
      border-radius: 10px;
      padding: 1px 5px;
      color: #fff;
    }

    margin: 10px auto;
  }
}

.flexs {
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  color: #fff;
}

.item {
  height: 46px;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px;
  margin-bottom: 5px;
  padding: 0 10px;

  .item_box {
    width: 100%;
    height: 320px;
    overflow-y: scroll;
    position: absolute;
    left: 0px;
    top:50px;
    background: #fff;
    box-shadow: 0 0 3px #999;
    border-radius: 10px;
    padding: 10px 10px 0px 10px;
    z-index: 10;

    .search-box {
      height: 40px;
      width: 100%;
      background: #eee;
      border-radius: 8px;
      margin-bottom: 10px;
      padding: 0 10px;
      box-sizing: border-box;

      input {
        width: 100%;
        height: 100%;
        font-size: 14px;
      }
    }

    a {
      display: block;
      width: 100%;
      height: 38px;
      border-bottom: 1px solid #eee;
      line-height: 38px;
      padding: 0 8px;
      cursor: pointer;
      display: flex;
      align-items: center;

      img {
        display: block;
        width: 32px;
        height: 20px;
        margin-right: 10px;
        border: 1px solid #eee;
      }
    }

    .active {
      background: #eee;
    }
  }

  .icon {
    width: auto;
    height: 20px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.get_captcha {
  width: 88px;
  height: 34px;
  background: linear-gradient(90deg,
      rgba(228, 57, 46, 1) 0%,
      rgba(254, 76, 22, 1) 100%);
  border-radius: 4px;
  text-align: center;
  line-height: 34px;
  font-size: 14px;
  color: #ffffff;
}

.protocol {
  font-size: 12px;
  line-height: 17px;
  margin-top: 20px;
  color: #999999;

  a {
    color: #3d96ff;
  }
}

.basic_btn {
  background: #10B981;
  margin: 102px auto 0 auto;
}

.text-phone {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-right: 15px;
  padding-bottom: 0px;
  line-height: 28px;
  background-image: url(~@/assets/images/xjt.png);
  background-repeat: no-repeat;
  background-size: 12px 12px;
  background-position: right center;
}

.big_tit {
  color: #fff !important;
}

.main-box {
  width: 100vw;
  max-width: 520px;
  height: 100dvh;
  position: relative;
  background-image: linear-gradient(90deg, #0d3a32, #082820 55%, #051a15);

  .box {
    width: 100%;
    height: 100%;
    position: relative;
    background-image: radial-gradient(circle at 82% 12%, rgba(52, 211, 153, .11), transparent 45%), radial-gradient(circle at 15% 96%, rgba(251, 191, 36, .1), transparent 40%);
    padding: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title-box {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      h2 {
        color: #fff;
      }

      .btn {
        border: 1px solid #2D4B44;
        border-radius: 15px;
        padding: 6px 9px;
        color: #fff;

        .iconfont {
          font-size: 18px;
        }
      }
    }

    .uls {
      width: 100%;
      height: 100%;
      margin-top: 20px;
      display: flex;
      flex-direction: column;

      .t {
        color: #ffffffa6;
        font-size: 11px;
        text-transform: uppercase;
      }

      .hr {
        margin-top: auto;
        width: 100%;
        height: 2px;
        background: #476052;
        margin-top: auto;
      }

      .t-box {
        width: 100%;
        height: fit-content;
        margin-top: 10px;
        padding: 12px;
        border-radius: 15px;
        border: 1.5px solid #518b80;
        background: #245547;
        background: linear-gradient(90deg, rgba(36, 85, 71, 1) 0%, rgba(43, 68, 47, 1) 100%);
        display: flex;
        align-items: center;
        position: relative;

        .li {
          width: 100%;
          height: fit-content;
          display: flex;
          border: 1px solid #4e8886;
          border-radius: 15px;
          padding: 12px;
          align-items: center;
          background: rgba(32, 67, 62, 0.5);

          .logos {
            width: fit-content;
            height: 18px;
            border: 1px solid #4D6D69;
            border-radius: 10px;
            margin-right: 10px;

            img {
              display: block;
              width: auto;
              height: 100%;
            }
          }

          .t-text {
            font-size: 14px;
            font-weight: bold;
            color: #ffffff;
          }

          .icon {
            .iconfont {
              font-size: 22px;
            }
          }
        }

        .boxs {
          position: relative;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 60px;
          z-index: 99;
          border-radius: 20px;
          background: #245547;
          background: linear-gradient(90deg, rgba(36, 85, 71, 1) 0%, #051A15 100%);
          overflow: hidden;
          overflow-y: scroll;
          padding: 12px;
          border: 1px solid #4e8886;

          .lis {
            width: 100%;
            display: flex;
            background: rgba(18, 46, 41, 0.3);
            border-radius: 10px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            padding: 15px;
            border: 1px solid #4e8886;

            img {
              display: block;
              width: auto;
              height: 16px;
              margin-right: 10px;
            }

            span {
              color: #fff;
              font-size: 14px
            }
          }
        }

        .icon {
          margin-left: auto;
          transition: 0.3s;

          .iconfont {
            font-size: 14px;
            color: #758678;
          }
        }

        .logo {
          padding: 7px;
          border-radius: 10px;
          margin-right: 10px;
          border: 1px solid #4A726A;

          .iconfont {
            color: #ffffff;
            font-size: 20px;
          }
        }

        .t-boxs {
          color: #ffffff;

          .t1 {
            font-size: 15px;
          }

          .t2 {
            font-size: 12px;
            margin-top: 8px;
          }
        }

        .boxs {
          width: 325px;
          height: fit-content;
          max-height: 256px;
          overflow: hidden;

          .active-li {
            background: rgba(43, 61, 34, 0.8) !important;
          }
        }
      }
    }
  }
}
</style>
